/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from "react";
import { Redirect } from "react-router-dom";
import Dashboard from "src/layouts/Dashboard";
import ErrorLayout from "src/layouts/ErrorLayout";

export default [
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/nuevo-presupuesto" />,
  },
  {
    path: "/errors",
    component: ErrorLayout,
    routes: [
      {
        path: "/errors/error-404",
        exact: true,
        component: lazy(() => import("src/views/Error404View")),
      },
      {
        component: () => <Redirect to="/errors/error-404" />,
      },
    ],
  },
  {
    path: "*",
    component: Dashboard,
    routes: [
      {
        path: "/detalle-presupuesto/:idPresupuesto",
        exact: true,
        component: lazy(() => import("src/views/presupuesto/VistaPresupuesto")),
      },
      {
        path: "/nuevo-presupuesto",
        exact: true,
        component: lazy(() => import("src/views/presupuesto/CargaPresupuesto")),
      },
      {
        path: "/lista-presupuesto",
        exact: true,
        component: lazy(() =>
          import("src/views/presupuesto/ListaPresupuestos")
        ),
      },
      {
        path: "/lista-clientes",
        exact: true,
        component: lazy(() => import("src/views/clientes/ListaClientes")),
      },
      {
        path: ["/carga-cliente", "/carga-cliente/:idCliente"],
        exact: true,
        component: lazy(() => import("src/views/clientes/CargaCliente")),
      },
      {
        path: "/lista-usuarios",
        exact: true,
        component: lazy(() => import("src/views/usuarios/ListaUsuarios")),
      },
      {
        component: () => <Redirect to="/errors/error-404" />,
      },
    ],
  },
  {
    component: () => <Redirect to="/errors/error-404" />,
  },
];
